import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";
import { Bold } from "@nib-components/copy";
import { Box } from "@nib/layout";

const StyledDiv = styled.div`
  ${breakpoint("md")`
    width: 80%;
    margin: 0 auto;
  `}
`;

const CourseEnhancements = ({ enhancements }) =>
  enhancements.length
    ? enhancements.map((enhancement, index) => (
        <StyledDiv key={index}>
          <Box marginVertical={{ xs: 3, lg: 4 }}>
            <Bold>{enhancement.name}:</Bold> {enhancement.details}
          </Box>
        </StyledDiv>
      ))
    : null;

CourseEnhancements.propTypes = {
  enhancements: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      details: PropTypes.string,
    })
  ),
};

export default CourseEnhancements;
